import CardCursos from "components/CardCursos";
// import Contact from "components/Contact";
import React from "react";

const Entrenamientos = () => {
  return (
    <div>
      <div className="w-full py-20 bg-purple-500">
        <h1>Cursos de entrenamiento</h1>
      </div>
      <div className="flex flex-row pt-20">
        <div className="w-1/2">1</div>
        <div className="w-1/3 mx-auto text-left">
          <p>
            Queremos que obtengas los mejores resultados a la hora de presentar
            tu examen de certificación en inglés ya sea internacional o
            nacional, por eso te ofrecemos una excelente preparacion de la
            mano de docentes expertos en las diferentes habilidades evaluadas.
            Conoce nuestros cursos de entrenamiento en IELTS, TOEFL y APTIS
          </p>
        </div>
      </div>
      <div>
        <p className="w-1/2">
          Cada curso está meticulosamente estructurado para reforzar todas las
          habilidades evaluadas en estas pruebas: comprensión auditiva, lectura,
          escritura y expresión oral.
        </p>
      </div>
      <div className="w-full pt-20">
        <h1>Nuestros cursos de entrenamiento </h1>
        <div className="grid grid-flow-col gap-5 w-max mx-auto">
          <CardCursos />
          <CardCursos />
          <CardCursos />
        </div>
      </div>
      <div>
        <p className="px-20">
          Beneficios de Nuestros Cursos: Personalización: Adaptamos nuestro
          enfoque de enseñanza según tus necesidades específicas y áreas de
          mejora. Práctica Intensiva: Ofrecemos múltiples oportunidades para
          practicar con ejercicios y exámenes simulados que replican las
          condiciones reales del test. Apoyo Integral: Acompañamos tu progreso
          con retroalimentación constante y asesoramiento individualizado de
          nuestros expertos.
        </p>
      </div>
      <div className="py-20 flex flex-row gap-5 items-center">
        <div className="w-1/3 mx-auto">
          <p>
            Contamos con mas de 12 años de experiencia preparando a nuestros
            candidatos en los examenes internacionales y nacionales de
            certificacion en inglés mas reconocidos como IELTS, TOEFL y APTIS
          </p>
        </div>
        <div className="w-1/2 flex flex-row gap-5">
          <div className="flex flex-row justify-center items-center p-5 w-[300px] gap-3 rounded-lg bg-rose-400 backdrop-blur-md bg-opacity-40 text-rose-800">
            <i class="fa-solid fa-award text-6xl" />
            <div className="text-left">
              <p className="text-3xl font-semibold">321+</p>
              <p>Estudiantes Certificados en IELTS</p>
            </div>
          </div>
          <div className="flex flex-row justify-center items-center p-5 w-[300px] gap-3 rounded-lg bg-lime-400 backdrop-blur-md bg-opacity-40 text-lime-600">
            <i class="fa-solid fa-trophy text-6xl" />
            <div className="text-left">
              <p className="text-3xl font-semibold">1700+</p>
              <p>Estudiantes Certificados en APTIS</p>
            </div>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-500">
        <div className="flex flex-row bg-gray-400 w-4/5 mx-auto -translate-y-24 p-5 rounded-[20px] ">
          <div className="w-1/3 mx-auto">
            <p>¡Prepárate para tu futuro hoy mismo! </p>
            <p>
              Ponte en contacto con nosotros para obtener más información sobre
              cómo nuestros cursos de entrenamiento a exámenes pueden ayudarte a
              alcanzar tus metas de certificación en inglés. Estamos aquí para
              apoyarte en cada paso del camino hacia el éxito académico y
              profesional.
            </p>
          </div>
          <div className="w-1/2">
            {/* <Contact /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Entrenamientos;
